import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { convertFiltersToFiltersDisplay } from './utils/filters';

interface FiltersProps {
  filters?: Record<string, unknown>;
}

const Filters = ({ filters }: FiltersProps) => {
  const filterDisplays = filters ? convertFiltersToFiltersDisplay(filters) : [];
  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        {filterDisplays.map((filter, idx) => (
          <View key={filter.displayName + idx} style={{ marginTop: 3, ...styles.rowSection }}>
            <Text style={styles.boldText}>{filter.displayName}:</Text>
            <Text>{filter.value || '--'}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  sectionContainer: {
    marginTop: 8,
    marginBottom: 19,
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    fontSize: 9,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  rowSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  boldText: { fontWeight: 'bold' },
});

export default Filters;
